import { render, staticRenderFns } from "./TableUserHotAlertConfigs.vue?vue&type=template&id=366e315e&"
import script from "./TableUserHotAlertConfigs.vue?vue&type=script&lang=js&"
export * from "./TableUserHotAlertConfigs.vue?vue&type=script&lang=js&"
import style0 from "./TableUserHotAlertConfigs.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports